import styled from 'styled-components';

export const DivStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Icon = styled.img`
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
  width: 14px !important;
  height: 15px !important;
`;

export const ValidationText = styled.p`
  display: flex;
  align-items: center;
  margin: 2px 0px;
  font-weight: 325;
  font-size: 14px;
  color: #475466;
  line-height: 18.2px;
  letter-spacing: -0.4px;
`;

export const ValidationTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #475466;
`;

export const ValidationContainer = styled.div<{
  responsive?: boolean,
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
  margin-left: 50px;
  gap: 8px;

  ${({ responsive }) => responsive && `
        h3, p {
          @media(max-width: 1366px) {
              font-size: 14px;
          }
        }
  `}
`;